const domain = window.location.hostname;
let API_PATH = "";
let API_PATH_TOOLS = "";
let API_PATH_GCOM = "";
const APP_LOCAL_PATH = "developer.gartner.com";
const APP_DEMO_PATH = ['tools-ha.pdotoolsqa.aws.gartner.com'];

const GCOM_ENV = {
  DEV: "https://gcom.pdodev.aws.gartner.com",
  QA: "https://gcom.pdoqa.aws.gartner.com",
  PROD: "https://www.gartner.com",
};
const TOOLS_ENV = {
  DEV: "https://toolsdv.gartner.com",
  QA: "https://toolsqa.gartner.com",
  DEMO: "https://demo.pdotoolsqa.aws.gartner.com",
  PROD: "https://tools.gartner.com",
};

let GENIE_AUTH_ENV = {
  LOCAL: "http://toolsdv.gartner.com/account/signin",
};

const APOLLO_HOST = {
  DEV: "tools.pdotoolsdev.aws.gartner.com, toolsdv.gartner.com, developer.gartner.com",
  QA: "tools.pdotoolsqa.aws.gartner.com, toolsqa.gartner.com, tools-ha.pdotoolsqa.aws.gartner.com",
  DEMO: "demo.pdotoolsqa.aws.gartner.com",
};

if (domain.indexOf(APP_LOCAL_PATH) !== -1) {
  API_PATH = "https://toolsdv.gartner.com";
}

if (APOLLO_HOST.DEV.indexOf(domain) !== -1) {
  API_PATH_TOOLS = TOOLS_ENV.DEV;
  API_PATH_GCOM = GCOM_ENV.DEV;
} else if (APOLLO_HOST.QA.indexOf(domain) !== -1) {
  API_PATH_TOOLS = TOOLS_ENV.QA;
  API_PATH_GCOM = GCOM_ENV.QA;
} else if (APOLLO_HOST.DEMO.indexOf(domain) !== -1) {
  API_PATH_TOOLS = TOOLS_ENV.DEMO;
  API_PATH_GCOM = GCOM_ENV.QA;
} else {
  API_PATH_TOOLS = TOOLS_ENV.PROD;
  API_PATH_GCOM = GCOM_ENV.PROD;
}

export const Constants = {
  GENIE_ACCESS_CODE: "genie_uid",
  API: {
    API_PATH: API_PATH,
    API_PATH_GCOM: API_PATH_GCOM,
    API_PATH_TOOLS: API_PATH_TOOLS,
    BASE_API_URL: "/api/cyber-risk/v1",
    AUTH: "/login",
    LOGOUT: "/api/auth/logout",
    LOGIN: "/account/signin",
  },
  ROUTES: {
    APP_LOCAL_PATH,
    APP_DEMO_PATH,
    BASE_URL: "/cybersecurity-insights",
    GENIE_AUTH_URL: GENIE_AUTH_ENV.LOCAL,
    GENIE_AUTH_URL_FE_ROUTE: '/account/signin',
    GENIE_AUTH_PARAMS: "&name=cybersecurity-insights&version=1",
  },
  LOGOUT_EVENT_KEY: "logout-event",
};
